import { HelpOutline } from '@mui/icons-material';
import { SvgIconProps, Tooltip } from '@mui/material';
import { VehicleCapability } from '@cnx-saas/shipment';
import {
  IconWrapper,
  VehicleCapabilityContainer,
} from './vehicle-capability-icon.styles';

import {
  Forklift,
  FrigoTruck,
  HydraulicRamp,
  RearLoading,
  SideLoading,
  Crane,
  PalletTruck,
} from './index';

type SvgIconComponent = (props: SvgIconProps) => JSX.Element;

const iconsByCapability: Partial<Record<VehicleCapability, SvgIconComponent>> =
  {
    [VehicleCapability.Cooled]: FrigoTruck,
    [VehicleCapability.SideLoading]: SideLoading,
    [VehicleCapability.RearLoading]: RearLoading,
    // [VehicleCapability.Curtainsider]: ,
    // [VehicleCapability.Edscha]: ,
    // [VehicleCapability.Sidewalls]: ,
    [VehicleCapability.PortableForklift]: Forklift,
    [VehicleCapability.HydraulicRamp]: HydraulicRamp,
    // [VehicleCapability.CodeXL]: ,
    // [VehicleCapability.PerforatedStrip]: ,
    [VehicleCapability.PalletTruck]: PalletTruck,
    [VehicleCapability.Crane]: Crane,
    // [VehicleCapability.CoilTruck]: ,
    // [VehicleCapability.JolodaSystem]: ,
    // [VehicleCapability.TensionBelts]: ,
    // [VehicleCapability.SideBoards]: ,
    // [VehicleCapability.Clipboards]: ,
    // [VehicleCapability.TensionChains]: ,
    // [VehicleCapability.LockingBars]: ,
    // [VehicleCapability.Kantenschoner]: ,
    // [VehicleCapability.AntiSlipMat]: ,
  };

interface VehicleCapabilityIconProps extends Pick<SvgIconProps, 'fontSize'> {
  readonly capability: VehicleCapability;
}

export const VehicleCapabilityIcon = ({
  capability,
  ...props
}: VehicleCapabilityIconProps) => {
  const Icon = iconsByCapability[capability] ?? HelpOutline;
  return (
    <VehicleCapabilityContainer>
      <Tooltip title={capability} placement="top">
        <IconWrapper>
          <Icon {...props} />
        </IconWrapper>
      </Tooltip>
    </VehicleCapabilityContainer>
  );
};
